import { useTranslation } from 'react-i18next';

export const ConcentrationPercentage = ({ concentration }: { concentration: number }) => {
  const { t } = useTranslation();

  const conz = concentration ? concentration : 0;
  return (
    <div className="flex">
      <div className="w-60">
        <div className="text-gray-600 text-xl font-bold">
          {t('measurements.totalConcentration')}
        </div>
        <div className="font-normal">{t('measurements.details.mil')}</div>
      </div>
      <div className="text-gray-600 text-3xl font-bold">{conz.toFixed(2)}</div>
    </div>
  );
};
